import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SelectorComponent } from './selector.component';
import { MatOptgroup, MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';

@NgModule({
    declarations: [
        SelectorComponent
    ],
    imports: [
        CommonModule,
        MatSelect,
        MatOption,
        MatOptgroup
    ],
    exports: [
        SelectorComponent
    ]
})
export class SelectorModule { }
